module.exports = __webpack_public_path__ + "static/img/registrationCn.27a13bb6.png";